import {computed, Signal, signal, WritableSignal} from '@angular/core';
import {uuidv4} from '@shared-types';

import {FileState, FileStateIcon, FileStateType} from './file-state.type';
import {FileModel} from './file.model';

export class UploadFileModel extends FileModel {
	id = uuidv4();
	state: WritableSignal<FileState> = signal<FileState>({
		state: FileStateType.New,
		icon: FileStateIcon[FileStateType.New],
		progress: 0,
		error: null,
	});

	stateIcon: Signal<FileState['icon']> = computed(() => this.state().icon);
	stateProgress: Signal<FileState['progress']> = computed(() => this.state().progress);
	stateError: Signal<FileState['error']> = computed(() => this.state().error);

	constructor(init: File | FileModel | UploadFileModel) {
		super(init instanceof File ? init : init instanceof FileModel ? init.file : init);
	}

	public setProgress(progress: number): void {
		if (progress === 0) {
			this.state.set({state: FileStateType.New, icon: FileStateIcon[FileStateType.New], progress: 0});
		} else if (progress > 0 && progress < 100) {
			this.state.set({
				state: FileStateType.Uploading,
				icon: FileStateIcon[FileStateType.Uploading],
				progress: progress,
			});
		} else if (progress === 100) {
			this.state.set({state: FileStateType.Uploaded, icon: FileStateIcon[FileStateType.Uploaded], progress: 100});
		} else {
			throw new Error('Progress must be between 0 and 100');
		}
	}

	public setError(error: string): void {
		this.state.update(state => {
			state.error = error;
			state.state = FileStateType.Error;
			state.icon = FileStateIcon[FileStateType.Error];
			state.progress = 0;
			return state;
		});
	}
}
